import carbonDriveCalculatorHtml from './carbondrivecalculator.component.html';
import './carbondrivecalculator.component.scss';

class CarbonDriveCalculatorController {
    constructor($scope, $window) {
        'ngInject';
        this.chainring = null;
        this.sprocket = null;
        this.chainstayLength = null;
        this.crankLength = null;
        this.useSprockets = 'enterSprockets';
        this.speedratio = null;
        this.wheelSize = null;
        this.beltDrives = [];
        this.selected = null;
        this.sortByColumn = 0;
        this.sortOrder = 'asc';

        this.DEFAULT_DIAMETER = 40
        this.MIN_DIAMETER = 10;
        this.MAX_DIAMETER = 400;
        this.MAX_PULLEYS = 10;
        this.BELT_PITCH = 11;

        this.pulleys = [];
        this.selIdx = -1;
        this.pulleyCnt = 0;
        this.cnv = null;
        this.ctx = null;
        this.canvasScale = 2;
        this.offsetX = 0;
        this.offsetY = 0;
        this.bAdvancedOptions = !1;

        this.frontSprockets = [22, 24, 26, 28, 32, 39, 42, 46, 50, 55, 60, 63, 70];
        this.rearSprockets = [19, 20, 21, 22, 23, 24, 26, 28, 30, 32, 34, 39];
        this.beltLengths = [108, 111, 113, 115, 118, 120, 122, 125, 128, 130, 132, 151, 158, 166, 174];
        this.fsItems = [
            ["beb", 22], ["beb", 24], ["beb", 26], ["5bcd", 46], ["5bcd", 50], ["5bcd", 55], ["5bcd", 60], ["5bcd", 70], ["pgb", 32],
            ["5di2", 50], ["4bcd", 39], ["4bcd", 42], ["4bcd", 46], ["4bcd", 50], ["4bcd", 55]
        ];
        this.rsItems = [
            ["9sp", 20], ["9sp", 22], ["9sp", 24], ["9sp", 26], ["9sp", 28], ["9sp", 30], ["9sp", 34], ["nex", 22], ["nex", 24], ["nex", 26],
            ["adi2", 28], ["sf3", 22], ["sf3", 24], ["sf3", 26], ["nuv", 24], ["nuv", 26], ["nuv", 28], ["srg8", 22], ["srg8", 24],
            ["srem", 22], ["rohl", 19], ["rohl", 20], ["rohl", 22], ["tofr", 22], ["tofi", 21]
        ];

        this.results = [];
        this.resultsFSprocketHead = '';
        this.resultsFSprocket = '';
        this.resultsRSprocketHead = '';
        this.resultsRSprocket = '';
        this.resultsAll = '';
        this.resultsPage = 1;
    }

    $onInit() {
        this.calculateGearRatio();
        this.hptDriveDesignInit();
    }

    selectResult(result) {
        this.selected = result;
        this.displaySelectedDrive();
    }

    hptDriveDesignInit() {
        this.cnv = document.getElementById('cnvMain'),
            this.ctx = this.cnv.getContext('2d');
    }

    calculateGearRatio() {
        const e = parseInt(this.chainring), t = parseInt(this.sprocket);
        this.speedratio = t > 0 ? (e / t).toFixed(3) : null;
    }

    findSolutions() {
        const targetRatio = this.speedratio,
            targetCD = this.chainstayLength;

        this.beltDrives = [];

        for (let e = 0; e < this.frontSprockets.length; e++) {
            for (let t = new pulley(this, "dd_pulley_0", 0, 0, this.frontSprockets[e]), s = 0; s < this.rearSprockets.length; s++) {
                for (let a = new pulley(this, "dd_pulley_1", 0, 0, this.rearSprockets[s]), i = 0; i < this.beltLengths.length; i++) {
                    let n = new drive(this, t, a, this.beltLengths[i]);
                    n.calcCD(), n.calcScore(targetCD, targetRatio), this.beltDrives[this.beltDrives.length] = n
                }
            }
        }

        this.beltDrives.sort(this.sortDriveByScore);

        this.results = [];
        this.resultsPage = 1;

        for (let e = 0; 30 > e; e++) {
            this.results.push([e + 1, (this.beltDrives[e].p1.teeth / this.beltDrives[e].p2.teeth).toFixed(3), this.beltDrives[e].p1.teeth, this.beltDrives[e].p2.teeth, this.beltDrives[e].b1, this.beltDrives[e].calcCD().toFixed(2)]);
        }

        if (this.results.length > 0) {
            this.selected = this.results[0];
        }

        //for (let e = 0; 30 > e; e++) oTable.fnAddData([e + 1, (beltDrives[e].p1.teeth / beltDrives[e].p2.teeth).toFixed(3), beltDrives[e].p1.teeth, beltDrives[e].p2.teeth, beltDrives[e].b1, beltDrives[e].calcCD().toFixed(2)]);

        /*oTable.fnDraw(), $(oTable.fnSettings().aoData[0]).each(function () {

            $(this.nTr).addClass("row_selected")

        });*/

        this.displaySelectedDrive();
    }

    sortResults(sortByColumn) {
        this.resultsPage = 1;

        if (this.sortByColumn === sortByColumn) {
            if (this.sortOrder === 'asc') {
                this.sortOrder = 'desc';
            } else {
                this.sortOrder = 'asc';
            }
        } else {
            this.sortOrder = 'asc';
        }

        this.sortByColumn = sortByColumn;

        let sortBefore = -1;
        let sortAfter = 1;

        if (this.sortOrder === 'desc') {
            sortBefore = 1;
            sortAfter = -1;
        }

        this.results.sort(function (a, b) {
            if (a[sortByColumn] < b[sortByColumn]) {
                return sortBefore;
            } else if (a[sortByColumn] > b[sortByColumn]) {
                return sortAfter;
            }
            return 0;
        });
    }

    get pages() {
        let pages = [];

        for (let i = 1; i <= Math.floor(this.results.length / 10); i++) {
            pages.push(i);
        }

        return pages;
    }

    sortDriveByScore(e, t) {
        let s = e.score;
        return t.score - s
    }

    displaySelectedDrive() {

        let crankRadius = this.crankLength, tireCircumference = parseInt(this.wheelSize), tireRadius = tireCircumference / (2 * Math.PI);

        let e = this.selected,
            t = e[2],
            s = e[3],
            a = e[4];

        this.pulleys.clear,
            this.pulleys[0] = new pulley(this, "dd_pulley_0", 0, 0, t),
            this.pulleys[0].index = 0,
            this.pulleys[1] = new pulley(this, "dd_pulley_1", 0, 0, s),
            this.pulleys[1].index = 1;

        let i = new drive(this, this.pulleys[0], this.pulleys[1], a),
            n = i.calcCD();

        this.pulleys[1].x = -n;

        let c, l = i.calcGearInches(tireRadius),
            r = i.calcGainRatio(tireRadius, crankRadius),
            o = i.calcDevelopment(tireRadius);

        this.draw();

        for (var h = "", u = 0; u < this.fsItems.length; u++)

            if (this.fsItems[u][1] == t)
                switch (h.length > 0 && (h += ", "), "5di2" == this.fsItems[u][0] && (h += "5 bolt Di2 130mm BCD"), "pgb" == this.fsItems[u][0] && (h += "Pinion gear box"), this.fsItems[u][0]) {
                    case "beb":
                        h += "Bosch eBike";
                        break;
                    case "4bcd":
                        h += "4 bolt 104mm BCD";
                        break;
                    case "5bcd":
                        h += "5 bolt 130mm BCD"
                }

        var d = "";

        for (u = 0; u < this.rsItems.length; u++)
            if (this.rsItems[u][1] == s) switch (d.length > 0 && (d += ", "), this.rsItems[u][0]) {
                case "9sp":
                    d += "9 spline hub";
                    break;
                case "nex":
                    d += "Nexus, Alfine";
                    break;
                case "adi2":
                    d += "Alfine Di2 3-Lobe";
                    break;
                case "sf3":
                    d += "SureFit 3-Lobe";
                    break;
                case "nuv":
                    d += "NuVinci";
                    break;
                case "srg8":
                    d += "SRAM G8";
                    break;
                case "srem":
                    d += "SRAM EMatic";
                    break;
                case "rohl":
                    d += "Rohloff";
                    break;
                case "tofr":
                    d += "Thread-On Freewheel";
                    break;
                case "tofi":
                    d += "Thread-On Fixed"
            }


        this.resultsFSprocketHead = "Mocowania przedniej zębatki:"
        this.resultsFSprocket = "&#160;&#160;" + h
        this.resultsRSprocketHead = "Mocowania tylnej zębatki:"
        this.resultsRSprocket = "&#160;&#160;" + d;
        c = "<strong>Development:</strong> " + o.toFixed(2) + " (m), <strong>Gear Inches:</strong> " + l.toFixed(3) + " (in),  <strong>Gain Ratio:</strong> " + r.toFixed(2);
        this.resultsAll = true === this.bAdvancedOptions ? c : "";

    }

    setAdvancedOptions() {
        this.wheelSize = this.bAdvancedOptions ? '1277' : null;
    }

    draw() {
        this.ctx.clearRect(0, 0, this.cnv.width, this.cnv.height);
        let e = 9999999.9, t = 9999999.9, s = -9999999.9, a = -9999999.9, i = null;

        for (let n = 0; n < this.pulleys.length; n++) {
            i = this.pulleys[n],
            i.x + i.pitchDiameter() / 2 > s && (s = i.x + i.pitchDiameter() / 2),
            i.y + i.pitchDiameter() / 2 > a && (a = i.y + i.pitchDiameter() / 2),
            i.x - i.pitchDiameter() / 2 < e && (e = i.x - i.pitchDiameter() / 2),
            i.y - i.pitchDiameter() / 2 < t && (t = i.y - i.pitchDiameter() / 2);
        }

        var c = s - e,
            l = a - t;

        this.canvasScale = c / this.cnv.width > l / this.cnv.height ? c / this.cnv.width * 1.1 : l / this.cnv.height * 1.1;

        var r = this.cnv.width / 2,
            o = this.cnv.height / 2;

        this.offsetX = r - r * this.canvasScale + (e + (s - e) / 2 - r),
            this.offsetY = -(o - o * this.canvasScale + (t + (a - t) / 2 - o));

        let maxPulleyRadius = 0;

        for (let pulley of this.pulleys) {
            if ((pulley.pitchDiameter() / 2)  > maxPulleyRadius) {
                maxPulleyRadius = (pulley.pitchDiameter() / 2);
            }
        }

        maxPulleyRadius += 20;

        for (let n = 0; n < this.pulleys.length; n++) {
            const pulley = this.pulleys[n];
            pulley.draw();

            this.ctx.beginPath();
            this.ctx.strokeStyle = 'rgb(128,128,128)';
            this.ctx.setLineDash([10, 5]);
            this.ctx.moveTo((pulley.x - this.offsetX) / this.canvasScale, (pulley.y + this.offsetY + 10) / this.canvasScale);
            this.ctx.lineTo((pulley.x - this.offsetX) / this.canvasScale, (pulley.y + this.offsetY + maxPulleyRadius + 10) / this.canvasScale);
            this.ctx.stroke();
            this.ctx.strokeStyle = 'rgb(0,0,0)';
            this.ctx.setLineDash([]);
        }

        this.ctx.beginPath();
        this.ctx.strokeStyle = 'rgb(128,128,128)';
        this.ctx.moveTo((this.pulleys[0].x - this.offsetX) / this.canvasScale + 5, Math.round((this.pulleys[0].y + this.offsetY + maxPulleyRadius + 5) / this.canvasScale));
        this.ctx.lineTo((this.pulleys[1].x - this.offsetX) / this.canvasScale - 5, Math.round((this.pulleys[1].y + this.offsetY + maxPulleyRadius + 5) / this.canvasScale));
        this.ctx.stroke();

        let textPosition = Math.round(((this.pulleys[0].x - this.offsetX) / this.canvasScale + (this.pulleys[1].x - this.offsetX) / this.canvasScale) / 2);
        this.ctx.font = '12px "Euclid Circular A"';
        this.ctx.textAlign = 'center';
        this.ctx.fillText('Rozstaw zębatek ' + this.selected[5] + 'mm', textPosition, Math.round((this.pulleys[0].y + this.offsetY + maxPulleyRadius) / this.canvasScale));

        this.drawBelt();
    }

    drawBelt() {
        if (!(this.pulleys.length < 2)) {
            let e = 0,
                t = 0;

            for (t = 0; t < this.pulleys.length; t++) {
                e = t == this.pulleys.length - 1 ? 0 : t + 1;
                var s = this.getSpan(this.pulleys[t], this.pulleys[e]);
                s.draw(), this.pulleys[t].span = s
            }
        }
    }


    getSpan(e, t) {
        return this.pulleyTangent(e, t, !1)
    }

    pulleyTangent(e, t, s) {
        var a = e.pitchDiameter() / 2,
            i = t.pitchDiameter() / 2,
            n = s ? i + a : i - a,
            c = Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)),
            l = Math.atan2(t.y - e.y, t.x - e.x),
            r = 0 == n ? 0 : Math.asin(n / c),
            o = 0;

        o = s && t.outsidePulley ? l - r - Math.PI / 2 : l + r + Math.PI / 2;

        var h = t.x + i * Math.cos(o),
            u = t.y + i * Math.sin(o);

        s && (o = e.outsidePulley ? l + r - Math.PI / 2 : l - r + Math.PI / 2);

        var d = e.x + a * Math.cos(o),
            p = e.y + a * Math.sin(o),
            f = new span(this);

        return f._init(d, p, h, u), f
    }
}

class pulley {

    constructor(that, e, t, s, a) {
        this.that = that, this.name = "", this.x = 0, this.y = 0, this.teeth = 0, this.span = null, this.outsidePulley = !1, this.overwrapped = !1, this.index = -1, this._moving = !1, this._hasBorder = !1, this._init = function (that, e, t, s, a) {
            this.that = that, this.name = e, this.x = t, this.y = s, this.teeth = a, this.span = new span
        }, this.pitchDiameter = function () {
            return this.teeth * that.BELT_PITCH / Math.PI
        }, this.hittest = function (e, t) {
            return Math.sqrt(Math.pow(this.x - e, 2) + Math.pow(this.y - t, 2)) < this.d / 2
        }, this.resizeHittest = function (e, t) {
            var s = Math.sqrt(Math.pow(this.x - e, 2) + Math.pow(this.y - t, 2));
            return Math.abs(s - this.d / 2) < 4
        }, this.octant = function (e, t) {
            var s = Math.atan2(t - this.y, e - this.x) - Math.PI / 8;
            return 0 > s && (s += 2 * Math.PI), Math.floor(s / (Math.PI / 4))
        }, this.draw = function () {
            that.ctx.strokeStyle = this.index == this.selIdx ? "rgb(255,0,0)" : "#000000";
            var e = this.pitchDiameter() / 2;
            that.ctx.beginPath(),
                that.ctx.arc((this.x - that.offsetX) / that.canvasScale, (this.y + that.offsetY) / that.canvasScale, e / that.canvasScale, 0, 2 * Math.PI, !1),
                that.ctx.moveTo((this.x - that.offsetX) / that.canvasScale, (this.y + that.offsetY - 5) / that.canvasScale),
                that.ctx.lineTo((this.x - that.offsetX) / that.canvasScale, (this.y + that.offsetY + 5) / that.canvasScale),
                that.ctx.moveTo((this.x - that.offsetX - 5) / that.canvasScale, (this.y + that.offsetY) / that.canvasScale),
                that.ctx.lineTo((this.x - that.offsetX + 5) / that.canvasScale, (this.y + that.offsetY) / that.canvasScale),
                that.ctx.stroke()
        }, this.move = function (e, t, s) {
            if (!s) s = this.d;
            if (s > that.MAX_DIAMETER && (s = that.MAX_DIAMETER), that.MIN_DIAMETER > s && (s = that.MIN_DIAMETER), this.d = s, !e) e = this.x;
            if (!t) t = this.y;
            var a = this.d / 2,
                i = cnv.w - this.d / 2 - 3;
            a > e && (e = a), e > i && (e = i), i = this.cnv.h - this.d / 2 - 3, a > t && (t = a), t > i && (t = i), this.x = e, this.y = t
        }, this.wrapAngle = function () {
        }, this.wrapLength = function () {
        }, this.select = function () {
            this.selIdx = this.index
        }, this.unselect = function () {
            this.selIdx = -1
        }, e && this._init(that, e, t, s, a)
    }
}

class span {
    constructor(that, e, t, s, a) {
        this.x0 = 0, this.y0 = 0, this.x1 = 0, this.y1 = 0, this._init = function (e, t, s, a) {
            this.x0 = e, this.y0 = t, this.x1 = s, this.y1 = a
        }, this.draw = function () {
            that.ctx.strokeStyle = "#000000", that.ctx.beginPath(), that.ctx.moveTo((this.x0 - that.offsetX) / that.canvasScale, (this.y0 + that.offsetY) / that.canvasScale), that.ctx.lineTo((this.x1 - that.offsetX) / that.canvasScale, (this.y1 + that.offsetY) / that.canvasScale), that.ctx.stroke()
        }, e && t && s && a && this._init(that, e, t, s, a)
    }
}

class drive {

    constructor(that, e, t, s) {
        this.that = that;
        this.p1 = 0;
        this.p2 = 0;
        this.b1 = 0;
        this.score = 0;
        this.e = e;
        this.t = t;
        this.s = s;
        e && t && s && this._init(this.that, e, t, s)
    }

    _init(that, e, t, s) {
        this.that = that, this.p1 = e, this.p2 = t, this.b1 = s;
    }

    beltLength(e, t, s) {
        if (e > t) var a = e,
            i = t;
        else a = t, i = e;
        var n = Math.asin((i - a) / (2 * s));
        return 2 * s * Math.cos(n) + Math.PI * (i + a) / 2 + n * (i - a)
    }

    calcCD() {
        var a, i = this.e.teeth * this.that.BELT_PITCH / Math.PI,
            n = this.t.teeth * this.that.BELT_PITCH / Math.PI,
            c = this.s * this.that.BELT_PITCH,
            l = (i + n) / 2;
        do {
            a = this.beltLength(i, n, l), l += (c - a) / 2
        } while (Math.abs(a - c) > 1e-4);
        return this.t.x = -l, l;
    }

    calcDevelopment(s) {
        return 2 * s * this.e.teeth / this.t.teeth * Math.PI / 1e3
    }

    calcGainRatio(s, a) {
        return s / a * this.e.teeth / this.t.teeth
    }

    calcGearInches(s) {
        return 2 * s * this.e.teeth / this.t.teeth / 25.4
    }

    calcSpeedRatio() {
        return this.e.teeth / this.t.teeth
    }

    calcScore(e, t) {
        var s, a;
        return s = 0 != t ? 1 - Math.abs((t - this.calcSpeedRatio()) / t) : 0, a = e > 0 ? 1 - Math.abs((e - this.calcCD()) / e) : 0, this.score = .5 * (s + a), this.score
    }
}


let carbonDriveCalculatorComponent = {
    bindings: {},
    template: carbonDriveCalculatorHtml,
    controller: CarbonDriveCalculatorController
}

export default carbonDriveCalculatorComponent;
